export default __webpack_public_path__ + "static/media/Zeki.888dafa4.png";